<template>
	<div class="page newpage">
		<div class="_flex">
			<el-date-picker v-model="search.time" type="date" value-format="yyyy-MM-dd" size="small"> </el-date-picker>
            <el-select v-model="search.created_by" clearable filterable size="small" placeholder="所属员工" style="margin-left: 10px;" @visible-change="selectAdmin">
                <el-option v-for="(item,index) in adminList" :key="index" :label="item.nick_name + ' / ' + item.phone" :value="item.admin_id"></el-option>
            </el-select>
            <div><el-button size="small" @click="req()" style="margin-left: 10px;" v-loading="loading" icon="el-icon-refresh">筛选</el-button></div>
		</div>
		<div class="_flex_sb mt_20">
			<div style="flex: 1 0 0;">
				<div class="f_22">日跟进趋势</div>
				<div class="_flex_sb c9 mt_20">
					<div>
						<div>累计跟进</div>
						<div class="f_40 c0">{{data.follow_count}}<span class="f_14 c9 ml_20">次</span></div>
					</div>
				</div>
				<div id="myChart" style="height:500px;"></div>
			</div>
			<div class="w_30 ml_20">
				<div class="f_22">跟进排名Top10</div>
				<div id="myChart1" style="width: 100%;min-height:590px;"></div>
			</div>
		</div>
	</div>
</template>

<script>
import * as echarts from 'echarts';
import { userFollowChartOne, adminLists } from "@/request/apis.js"
export default{
    data(){
        return {
			name:'',
            list : [{id:1,name:'通知公告'}],
			show : false,
			represShow : false,
			formData : {
				name : ''
			},

            loading: false,
            departArr: [],
            data: {},
            search: {
                time: '',
            },
            myChart: {},
            myChart1: {},
            adminList: [],
        }
    },
	mounted() {
		this.init()
        this.req();
	},
	methods:{
        async req(){
            this.loading = true;
            var res = await userFollowChartOne(this.search);
            this.loading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.search.time = res.data.time;
            this.data = res.data;

			this.myChart.setOption(res.data.chart_option);
            this.myChart1.setOption(res.data.top_option);
        },
		init(){
			//图一
			this.myChart = echarts.init(document.getElementById('myChart'));
			// this.myChart.setOption({
			//   tooltip: { trigger: 'axis', },
			//   legend: { show : true, data: ['次数', '员工'], right:10 },
			//   grid: { left: '1%', right: '1%', bottom: '0%', containLabel: true },
			//   xAxis: {
			// 	type: 'category',
			// 	data: ['1', '2', '3', '4', '5', '6', '7']
			//   },
			//   yAxis: { type: 'value' },
			//   series: [
			// 	{
			// 	  name: '次数',
			// 	  data: [820, 932, 901, 934, 1290, 1330, 1320],
			// 	  type: 'line',
			// 	  smooth: true
			// 	},{
			// 	  name: '员工',
			// 	  data: [80, 232, 901, 34, 1290, 330, 120],
			// 	  type: 'line',
			// 	  smooth: true
			// 	}
			//   ]
			// });
			//图二
			this.myChart1 = echarts.init(document.getElementById('myChart1'));
			// this.myChart1.setOption({
			//   tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
			//   legend: {show:false},
			//   grid: { left: '0%', right: '0%', bottom: '0%', containLabel: true },
			//   xAxis: { type: 'value', boundaryGap: [0, 0.01] },
			//   yAxis: { type: 'category', data: ['纯碱', '阿松', '吐奶', '去', '过', '图文', '都是', '为', '色温', '岗位'] },
			//   series: [ { name: '', type: 'bar', data: [183, 234, 290, 170, 144, 630, 290, 170, 144, 630] } ]
			// });
		},
        async selectAdmin(query){
            if (!query || this.adminList.length) {
                return false;
            }
            const res = await adminLists({limit: 1000})
            if (res.code) {
                return this.$message.error(res.msg)
            }
            this.adminList = res.data;
        },
	}
}
</script>

<style scoped>
</style> 